import { z } from 'zod';
import { storageLocationsSortByValues } from 'src/apis/storage/mappings';
import {
  descSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import {
  preprocessAsArray,
  preprocessAsBoolean,
} from 'src/components/form/zod-utilities';
import { ssoOptionSchema } from 'src/pages/storage/locations-new/components/sso-searchable-multi-select';

export function getStorageLocationsPageParamsSchema() {
  return z
    .object({
      sortBy: z
        .enum(storageLocationsSortByValues)
        .default('LOCATION_BUSINESS_ID'),
      sortDirection: descSortDirectionSchema,
      locationBusinessId: z
        .string()
        .regex(/^(STL-\d+)$/, '{label} must start from "STL-".')
        .nullable()
        .default(null),
      name: z.string().nullable().default(null),
      ssoOrganisationId: z.preprocess(
        preprocessAsArray,
        z.array(ssoOptionSchema).default([])
      ),
      marketAreaId: z.preprocess(
        preprocessAsArray,
        z.array(z.string()).default([])
      ),
      ownLocations: z.preprocess(
        preprocessAsBoolean,
        z.boolean().default(false)
      ),
    })
    .merge(getPaginationSchema());
}
